export default __webpack_public_path__ + "static/media/Menu.54699b56.svg";